import {
  AutocompleteInput,
  ReferenceInput,
  required,
  SelectInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const accountPayableAgeFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="cut_off"
      variant="outlined"
      label="mine.label.cut_off_date"
    />,
    <ReferenceInput
      alwaysOn
      source="start_created_at"
      reference="suppliers"
      sort={{ field: "suppliers.created_at", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        optionValue="created_at"
        optionText="code"
        variant="outlined"
        label="mine.label.start_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="end_created_at"
      reference="suppliers"
      sort={{ field: "suppliers.created_at", order: "ASC" }}
      perPage={10}
    >
      <AutocompleteInput
        resettable
        optionValue="created_at"
        optionText="code"
        variant="outlined"
        label="mine.label.end_code"
        // filterToQuery={(search) => ({ created_at: search })}
      />
    </ReferenceInput>,
    <SelectInput
      alwaysOn
      source="kind"
      variant="outlined"
      label="mine.label.kind"
      validate={required()}
      choices={[
        { id: "per_surat_jalan", name: "Per Surat Jalan" },
        { id: "per_jatuh_tempo", name: "Per Jatuh Tempo" },
      ]}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default accountPayableAgeFilterList;
